import { FAVORITE_DASHBOARDS_KEY } from '../../constants';
import { JsonLocalStorageService } from '../local-storage-service';
import { FavoriteDashboardRating } from './types';

export const LocalStorageFavoriteDashboardRatingService =
  new JsonLocalStorageService<FavoriteDashboardRating>(FAVORITE_DASHBOARDS_KEY);
